var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 17.5-.083-.125c-.579-.868-.868-1.302-1.25-1.617a3.334 3.334 0 0 0-1.149-.614C7.545 15 7.023 15 5.98 15H4.834c-.934 0-1.4 0-1.757-.182a1.666 1.666 0 0 1-.728-.728c-.182-.357-.182-.823-.182-1.757V5.167c0-.934 0-1.4.182-1.757.16-.314.414-.569.728-.728C3.434 2.5 3.9 2.5 4.834 2.5h.333c1.867 0 2.8 0 3.513.363.627.32 1.137.83 1.457 1.457.363.713.363 1.646.363 3.513m0 9.667V7.833m0 9.667.084-.125c.579-.868.868-1.302 1.25-1.617a3.333 3.333 0 0 1 1.148-.614c.474-.144.996-.144 2.04-.144h1.145c.933 0 1.4 0 1.757-.182.313-.16.568-.414.728-.728.182-.357.182-.823.182-1.757V5.167c0-.934 0-1.4-.182-1.757a1.667 1.667 0 0 0-.728-.728C17.567 2.5 17.1 2.5 16.167 2.5h-.333c-1.867 0-2.8 0-3.514.363-.627.32-1.137.83-1.456 1.457-.364.713-.364 1.646-.364 3.513",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen01);
export default __webpack_public_path__ + "static/media/bookOpen01.a31c2acf6ff8cd1d3d03afa0c3eaba62.svg";
export { ForwardRef as ReactComponent };